import { render, staticRenderFns } from "./singleTaskList.vue?vue&type=template&id=68ed714e&scoped=true"
import script from "./singleTaskList.vue?vue&type=script&lang=js"
export * from "./singleTaskList.vue?vue&type=script&lang=js"
import style0 from "./singleTaskList.vue?vue&type=style&index=0&id=68ed714e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed714e",
  null
  
)

export default component.exports